import {Text} from '@mantine/core';
import {useModals} from '@mantine/modals';
import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import getNestedKey from 'shared/util/get-nested-key';

export interface ApiDeleteButtonProps {
  url: string;
  queryKey: any;
  field?: string;
  idKey?: string;
  method?: string;
  inifiteQuery?: boolean;
}

const useButtonState = ({
  url,
  queryKey,
  method = 'DELETE',
  field,
  idKey,
  inifiteQuery = false,
}: ApiDeleteButtonProps) => {
  const queryHelpers = useQueryHelpers();
  const infiniteQueryHelpers = useInfiniteQueryHelpers();
  const {openConfirmModal} = useModals();

  const onSuccess = (data: any) => {
    if (idKey && !inifiteQuery)
      return queryHelpers.filter(
        queryKey,
        (data) => getNestedKey(data, idKey) !== field,
      );
    if (idKey && inifiteQuery)
      return infiniteQueryHelpers.remove(queryKey, {[idKey]: field});
    queryHelpers.remove(queryKey, data);
  };

  const {mutate, isLoading} = useApiMutation({
    method,
    url,
    errorTitle: 'Erro ao remover registro',
    successTitle: 'Remover registro',
    successMessage: 'Registro removido com sucesso',
    onSuccess,
  });

  const handleRequest = (field: string) =>
    openConfirmModal({
      title: 'Confirme para remover',
      children: <Text>Deseja realmente remover o registro?</Text>,
      labels: {confirm: 'Sim', cancel: 'Não'},
      onConfirm: () => mutate({id: field}),
    });

  return {
    handleRequest,
    isLoading,
  };
};

export default useButtonState;
